import * as qs from "qs";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors"; 

export function getAllJobsSearch(search, latitude,longitude,distance,salaryMin,salaryType,jobType,postedOn,workStatus,itemsPerPage, so
  ) {
  return axiosInterceptors
    .get(
      ENV.alljobs_url +
        "candidate/search/alljobs",
      {
        params: {
          search: search,
          latitude:latitude,
          longitude:longitude,
          distance:distance,
          salaryMin:salaryMin,
          salaryType:salaryType,
          postedOn:postedOn,
          jobType:jobType,
          workStatus:workStatus,
          ps: itemsPerPage,
          so:so,
        },
        paramsSerializer: (params) => {
          var qps = qs.stringify(params, { arrayFormat: "repeat" });
          return qps;
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}
